import React, { useEffect } from "react";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useModal } from "../hooks/useModal";
import AddCardForm from "./addCard";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

export default function AddCardPrompt() {
  const { openModal, closeModal, view } = useModal();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_VALUE ?? "");

  const addCard = () =>
    openModal({
      view: (
        <Elements stripe={stripePromise}>
          <AddCardForm />
        </Elements>
      ),
    });
  return (
    <div className="w-[96%] md:w-[402px] mx-auto bg-background dark:bg-[#2A2C30] p-[32px] rounded-[8px] shadow-lg">
      <div className="flex flex-col gap-[41px] text-center">
        <div className="flex flex-col gap-[8px]">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            Add card
          </Text>
          <Text className="font-switzer text-[14px] text-[#758599] font-[400]">
            You need to add a card before you can fund your wallet. Please add
            one to proceed
          </Text>
        </div>
        <div className="flex gap-[18px] justify-center">
          <ActionIcon
            className="w-[109px] h-[35px] rounded-[4px] !bg-[#F2F2F2] dark:!bg-muted"
            onClick={closeModal}
          >
            <Text className="font-[400] text-[12px] text-[#191919] dark:text-[#F2F2F2] font-switzer">
              Cancel
            </Text>
          </ActionIcon>
          <ActionIcon
            className="w-[109px] h-[35px] rounded-[4px] !bg-btn"
            onClick={addCard}
          >
            <Text className="font-[400] text-[12px] text-background font-switzer">
              Add card
            </Text>
          </ActionIcon>
        </div>
      </div>
    </div>
  );
}
